<template>
<svg class="radio-button" :class="{checked: checked}" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="11.5" stroke="white"/>
<!-- <rect x="41.5814" y="14.2109" width="1" height="38" rx="0.5" transform="rotate(45 41.5814 14.2109)" fill="#E8FF03"/>
<rect x="42.2886" y="41.0811" width="1" height="38" rx="0.5" transform="rotate(135 42.2886 41.0811)" fill="#E8FF03"/> -->
</svg>
</template>


<script>
export default {
    props: ['checked']
}
</script>

<style lang="scss" scoped>
circle {
    stroke: white;
    stroke-width: 2px;
}

svg {
    cursor: pointer;

    &:hover, &.checked {
        circle {
            fill: var(--col-orange);
        }
    }
}
</style>